import { useRecoilValue } from 'recoil';

import { masterState } from '../../store/master/atom';
import { sessionState } from '../../store/session/atom';

export const useImpersonate = () => {
  const { userProfile } = useRecoilValue(sessionState);
  const { selectedAdvisor, selectedPartner } = useRecoilValue(masterState);

  const isAllAdvisors = selectedAdvisor === 0;
  const isAllPartners = selectedPartner === 0;

  const isDifferentAdvisor =
    (!!selectedAdvisor && userProfile?.idAssessorIntranet !== selectedAdvisor) || isAllAdvisors;
  const isDifferentPartner =
    (!!selectedPartner && userProfile?.idParceiro !== selectedPartner) || isAllPartners;

  const hasSomeImpersonation = isDifferentAdvisor || isDifferentPartner;

  return {
    isAllAdvisors,
    isAllPartners,
    isDifferentAdvisor,
    isDifferentPartner,
    hasSomeImpersonation,
  };
};
